var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStorageSites({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.47437 7.91053V27.7609C9.47437 28.4063 9.99829 28.9302 10.6437 28.9302C11.289 28.9302 11.813 28.4063 11.813 27.7609V7.91053C11.813 7.26514 11.289 6.74121 10.6437 6.74121C9.99829 6.74121 9.47437 7.26514 9.47437 7.91053Z",
    fill: "#135FC2",
    fillOpacity: 0.05
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.4822 23.0331V10.6107C37.4821 8.24279 35.5626 6.32324 33.1947 6.32324C26.9627 6.32324 13.034 6.32324 6.80201 6.32324C4.43408 6.32324 2.51453 8.24279 2.51453 10.6107V28.3641C2.51453 30.732 4.43408 32.6516 6.80197 32.6516H21.891C23.0916 32.6516 24.2373 32.1481 25.0493 31.2637L28.0902 27.9514C28.4594 27.5494 28.98 27.3205 29.5258 27.3205H33.1947C35.5626 27.3205 37.4821 25.401 37.4822 23.0331ZM35.1435 11.0005V10.6107C35.1435 9.53439 34.271 8.66188 33.1946 8.66188C33.1946 8.66188 6.80205 8.66188 6.80194 8.66188C5.72568 8.66188 4.8532 9.53439 4.85316 10.6107C4.85316 10.6107 4.85316 28.364 4.85316 28.3641C4.8532 29.4404 5.72568 30.3129 6.80201 30.313C6.80201 30.313 21.8909 30.313 21.8911 30.313C22.4367 30.3129 22.9574 30.0841 23.3266 29.682L26.3675 26.3698C27.1796 25.4853 28.3252 24.9819 29.5258 24.9819H33.1947C34.271 24.9818 35.1435 24.1094 35.1435 23.033V22.6937H29.3529C28.7075 22.6937 28.1836 22.1697 28.1836 21.5244C28.1836 20.879 28.7075 20.355 29.3529 20.355H35.1435V18.0164H29.3529C28.7075 18.0164 28.1836 17.4924 28.1836 16.8471C28.1836 16.2017 28.7075 15.6778 29.3529 15.6778H35.1435V13.3391H29.3529C28.7075 13.3391 28.1836 12.8152 28.1836 12.1698C28.1836 11.5244 28.7075 11.0005 29.3529 11.0005H35.1435Z",
    fill: "#135FC2",
    fillOpacity: 0.05
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStorageSites);
export default __webpack_public_path__ + "static/media/StorageSites.234f36f2d4c0d1425abb3618ca26bdc7.svg";
export { ForwardRef as ReactComponent };